import { render, staticRenderFns } from "./FormMultiFile.vue?vue&type=template&id=4aac7706&lang=pug"
import script from "./FormMultiFile.vue?vue&type=script&lang=ts"
export * from "./FormMultiFile.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports